/**
 * UI包装成ProgressTimer
 */
let UIProgressTimer = xClass("UIProgressTimer", function (node, bounds0){
    return node;
})

const Direction = {
    kLeftToRight: 0,
    kRightToLeft: 1
}

const AnchorPointMap = {
    [Direction.kLeftToRight]: cc.p(0, 0),
    [Direction.kRightToLeft]: cc.p(1, 0),
}

// 如果topChild不是sprite，这时候可能会用得到bounds0来定宽高
//direction = 1 是从左向右的
UIProgressTimer.prototype.ctor = function (node, bounds0) {
    this.percent = 0;
    
    let children = node.getChildren();
    let topChild = children[children.length - 1];
    let bounds = topChild.getBoundingBox();
    if (bounds0){
        bounds.width = bounds0.width;
        bounds.height = bounds0.height;
    }
    let pos = topChild.getPosition();
    topChild.removeFromParent(false);
    topChild.setScale(1);

    let progress = cc.ClippingRectangleNode.create()
    progress.addChild(topChild);
    topChild.setPosition(pos.x - bounds.x, pos.y - bounds.y);
    progress.setPosition(bounds.x, bounds.y);
    progress.setAnchorPoint(AnchorPointMap[Direction.kLeftToRight]);
    node.addChild(progress);
    progress.setContentSize(bounds.width, bounds.height);
    progress.setClippingRegion(cc.rect(0, 0, bounds.width, bounds.height));

    this.direction = 0;

    this.progressBar = progress;
    this.progressBarChild = topChild;
    this.pWidth = bounds.width;
    this.pHeight = bounds.height;
    this.progress = 1;

    this.speed = 0;
    this.targetWidth = null;
}

UIProgressTimer.prototype.setProgressBarChildPositionOffset = function(p) {
    var p0 = this.progressBarChild.getPosition();
    this.progressBarChild.setPosition(cc.pAdd(p0, p));
}

UIProgressTimer.prototype.setContentOffset = function(x, y) {
    this.progressBar.setPosition(x, y);
}

UIProgressTimer.prototype.getContentOffset = function() {
    return this.progressBar.getPosition();
}

UIProgressTimer.prototype.getLength = function() {
    return this.pWidth;
}

UIProgressTimer.prototype.setProgress = function (progress, duration) {
    if (this.progress != progress) {
        this.progress = progress;
        let targetWidth = this.pWidth * progress;      
        if (duration == null || duration <= 0) {
            this.stop();
            if (this.direction == 0){
                this.progressBar.setClippingRegion(cc.rect(0, 0, targetWidth, this.pHeight));
            }else{
                this.progressBar.setClippingRegion(cc.rect(this.pWidth * (1-progress), 0, targetWidth, this.pHeight));
            }
        } else {
            let region = this.progressBar.getClippingRegion();
            this.speed = (targetWidth - region.width) / duration; 
            this.targetWidth = targetWidth;
            
            this.scheduleUpdate();
        }
    } 
}

UIProgressTimer.prototype.stop = function() {
    this.unscheduleUpdate();
    this.speed = 0;
    this.targetWidth = null;
}

UIProgressTimer.prototype.update = function(deltaSec) {
    let region = this.progressBar.getClippingRegion();
    let newWidth = region.width + deltaSec * this.speed;
    let dx = 0;
    if (this.direction == 1){
        dx = deltaSec * this.speed;
    }
    let offset = this.targetWidth - newWidth;
    if (Math.abs(offset) < 1) {
        newWidth = this.targetWidth;
        this.stop();
    } else if ((this.speed < 0 && offset > 0) || (this.speed > 0 && offset < 0)) {
        newWidth = this.targetWidth;
        this.stop();
    }
    region.width = newWidth;
    region.x -= dx;
    this.progressBar.setClippingRegion(region);
}

module.exports = UIProgressTimer
